import { Link } from "react-router-dom";
import DraftingImg from "@/assets/images/3D/3d.png";
import TakeoffImg from "@/assets/images/3D/3d15.png";

const services = [
    {
        key: "drafting",
        label: "Drafting Services",
        badge: "CAD & Drafting Support",
        title: "Drafting Services",
        description:
            "We act as an extension of your design team, translating your redlines, hand sketches, and design parameters into meticulously organized, layered DWG and PDF files. We focus on exact dimensional accuracy so your licensed professionals can review, stamp, and submit with complete confidence.",
        highlights: [
            "Paper-to-CAD Conversions",
            "2D Floor Plans & Elevations",
            "As-Built Documentation Support",
            "3D Photorealistic Renderings",
        ],
        image: DraftingImg,
        link: "/services/drafting",
        linkLabel: "Explore Drafting Services",
        accentFrom: "#e18033",
        accentTo: "#c96a1a",
        icon: "ri-draft-line",
    },
    {
        key: "takeoff",
        label: "Takeoff Services",
        badge: "Material Quantity Takeoffs",
        title: "Takeoff Services",
        description:
            "An accurate bid starts with an accurate count. We extract comprehensive, line-item material quantities, specifically for low voltage companies, directly from your blueprints. By outsourcing the tedious measurement phase, your in-house estimators save hours of time and can quickly apply local pricing to win more bids.",
        highlights: [
            "Comprehensive Material Takeoffs",
            "Trade-Specific Quantity Extractions",
            "Color-Coded PDF Visual Markups",
        ],
        image: TakeoffImg,
        link: "/services/takeoff",
        linkLabel: "Explore Takeoff Services",
        accentFrom: "#0d9488",
        accentTo: "#0f766e",
        icon: "ri-calculator-line",
    },
];

export default function ServicesShowcaseSection() {
    return (
        <section className="py-20 bg-[#f8f5f1] dark:bg-slate-800/50 transition-colors duration-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <div className="text-center mb-14">
                    <span className="inline-block px-4 py-1.5 bg-[#e18033]/10 dark:bg-[#e18033]/20 text-[#e18033] text-sm font-semibold rounded-full mb-4 tracking-wide uppercase">
                        Our Services
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold text-[#212026] dark:text-gray-100 mb-4">
                        What We Deliver
                    </h2>
                    <p className="text-[#889d8f] dark:text-gray-400 max-w-2xl mx-auto text-lg">
                        You provide the design parameters; we provide the exact technical execution.
                    </p>
                </div>

                {/* Split Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {services.map((service) => (
                        <div
                            key={service.key}
                            className="group relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
                        >
                            {/* Background Image */}
                            <div className="relative h-72 overflow-hidden">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                                />
                                {/* Gradient overlay */}
                                <div
                                    className="absolute inset-0"
                                    style={{
                                        background: `linear-gradient(to bottom, rgba(33,32,38,0.15) 0%, rgba(33,32,38,0.85) 100%)`,
                                    }}
                                />
                                {/* Badge */}
                                <div className="absolute top-5 left-5">
                                    <span
                                        className="px-3 py-1.5 text-white text-xs font-bold rounded-full uppercase tracking-wider"
                                        style={{ backgroundColor: service.accentFrom }}
                                    >
                                        {service.badge}
                                    </span>
                                </div>
                                {/* Icon */}
                                <div
                                    className="absolute top-5 right-5 w-11 h-11 rounded-full flex items-center justify-center"
                                    style={{ backgroundColor: `${service.accentFrom}33` }}
                                >
                                    <i
                                        className={`${service.icon} text-white text-xl`}
                                    ></i>
                                </div>
                                {/* Title on image */}
                                <div className="absolute bottom-5 left-5 right-5">
                                    <h3 className="text-2xl font-bold text-white mb-1">
                                        {service.title}
                                    </h3>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="bg-white dark:bg-slate-800 p-7 transition-colors duration-300">
                                <p className="text-[#889d8f] dark:text-gray-400 text-base leading-relaxed mb-6">
                                    {service.description}
                                </p>

                                {/* Highlights */}
                                <div className="grid grid-cols-2 gap-2 mb-7">
                                    {service.highlights.map((item) => (
                                        <div
                                            key={item}
                                            className="flex items-center gap-2 text-sm text-[#212026] dark:text-gray-300"
                                        >
                                            <span
                                                className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                                                style={{ backgroundColor: service.accentFrom }}
                                            />
                                            {item}
                                        </div>
                                    ))}
                                </div>

                                {/* CTA */}
                                <Link
                                    to={service.link}
                                    className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-white font-semibold text-sm transition-all duration-300 hover:gap-3 hover:shadow-lg"
                                    style={{
                                        background: `linear-gradient(135deg, ${service.accentFrom}, ${service.accentTo})`,
                                    }}
                                >
                                    {service.linkLabel}
                                    <i className="ri-arrow-right-line text-base"></i>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
